import {Component, OnInit} from '@angular/core';

import {VehicleService} from '@commons/services/vehicle/vehicle.service';
import {Vehicle} from "@commons/models/domain/Vehicle";

import {DialogService} from "@shared/services/dialog.service";

import {LinkViewModel} from "@data-sharing/view-models/link-view-model";
import {AddedLinkModalComponent} from './components/added-link-modal/added-link-modal.component';
import {DataSharingHttpService} from "@data-sharing/http-services/data-sharing-http.service";

@Component({
  selector: 'dsm-links-list',
  templateUrl: './links-list.component.html',
  styleUrls: ['./links-list.component.scss']
})
export class LinksListComponent implements OnInit {

  isLoading = false;
  isListVisible = true;
  isAddLinkVisible = false;
  vehicles: Vehicle[] = [];
  search = '';
  linkToView?: LinkViewModel;
  rows: LinkViewModel[] = [];

  constructor(
    private vehicleService: VehicleService,
    private dialogService: DialogService,
    private dataSharingHttpService: DataSharingHttpService

  ) {
    this.loadVehicles();
  }

  ngOnInit(): void {
    this.loadLinks();
  }

  onViewLink(linkViewModel: LinkViewModel) {
    this.linkToView = linkViewModel;

    this.isListVisible = false;
    this.isAddLinkVisible = true;
  }

  onAddLink() {
    this.isListVisible = !this.isListVisible;
    this.isAddLinkVisible = !this.isAddLinkVisible;

    if (this.isAddLinkVisible)
      this.linkToView = undefined;
  }

  onLinkAdded(linkViewModel: LinkViewModel) {
    this.isListVisible = true;
    this.isAddLinkVisible = false;

    if (linkViewModel) {
      this.dialogService.open(AddedLinkModalComponent, linkViewModel);
      this.rows.push(linkViewModel);
    }
  }

  private loadVehicles() {
    let interval = setInterval(() => {
      if (this.vehicles.length === 0) {
        this.vehicleService.getList$().subscribe(vehicles => {
          this.vehicles = vehicles;
        });
      } else {
        clearInterval(interval);
      }
    }, 100);
  }

  private loadLinks() {
    this.isLoading = true;
    this.dataSharingHttpService.getAll().subscribe(links => {
      const models = [];
      for (const link of links) {
        let model = new LinkViewModel(link, []);
        models.push(model);
      }
      this.rows = models;
      this.isLoading = false;
    });
  }

  onSearchChanged(search: string) {
    this.search = search;
  }

  onReloadList() {
    this.loadLinks();
  }
}
